import { Container, Table } from "react-bootstrap";
import { memo } from "react";

interface RecordingTableSkeletonProps {
  rows?: number;
}

const RecordingTableSkeleton = memo(function RecordingTableSkeleton({ rows = 5 }: RecordingTableSkeletonProps) {
  const skeletonRows = Array(rows).fill(0);

  return (
    <Container fluid>
      <Table striped bordered hover variant="dark">
        <thead>
          <tr>
            <th>#</th>
            <th>Recording Name</th>
            <th>Start Timestamp</th>
            <th>Duration</th>
            <th>Download</th>
          </tr>
        </thead>
        <tbody>
          {skeletonRows.map((_, index) => (
            <tr key={index}>
              <td>
                <div 
                  className="skeleton-box" 
                  style={{
                    height: '1rem',
                    width: '2rem',
                    backgroundColor: '#495057',
                    borderRadius: '4px',
                    animation: 'skeleton-loading 1.5s infinite ease-in-out'
                  }}
                />
              </td>
              <td>
                <div 
                  className="skeleton-box" 
                  style={{
                    height: '1rem',
                    width: '80%',
                    backgroundColor: '#495057',
                    borderRadius: '4px',
                    animation: 'skeleton-loading 1.5s infinite ease-in-out',
                    animationDelay: '0.1s'
                  }}
                />
              </td>
              <td>
                <div 
                  className="skeleton-box" 
                  style={{
                    height: '1rem',
                    width: '70%',
                    backgroundColor: '#495057',
                    borderRadius: '4px',
                    animation: 'skeleton-loading 1.5s infinite ease-in-out',
                    animationDelay: '0.2s'
                  }}
                />
              </td>
              <td>
                <div 
                  className="skeleton-box" 
                  style={{
                    height: '1rem',
                    width: '50%',
                    backgroundColor: '#495057',
                    borderRadius: '4px',
                    animation: 'skeleton-loading 1.5s infinite ease-in-out',
                    animationDelay: '0.3s'
                  }}
                />
              </td>
              <td className="text-center">
                <div 
                  className="d-flex justify-content-center gap-3"
                >
                  {[0, 1, 2].map((iconIndex) => (
                    <div
                      key={iconIndex}
                      className="skeleton-box"
                      style={{
                        height: '1.5rem',
                        width: '1.5rem',
                        backgroundColor: '#495057',
                        borderRadius: '4px',
                        animation: 'skeleton-loading 1.5s infinite ease-in-out',
                        animationDelay: `${0.4 + iconIndex * 0.1}s`
                      }}
                    />
                  ))}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <style>{`
        @keyframes skeleton-loading {
          0% {
            opacity: 1;
          }
          50% {
            opacity: 0.4;
          }
          100% {
            opacity: 1;
          }
        }
        
        .skeleton-box {
          display: inline-block;
        }
      `}</style>
    </Container>
  );
});

export default RecordingTableSkeleton;